module.exports = __webpack_public_path__ + "assets/img/11_1594_big.bc38ce00.jpg";